import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FavoritesPage.css';

function FavoritesPage() {
  const [favorites, setFavorites] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadFavorites();
    
    const handleStorageChange = () => {
      loadFavorites();
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('favoritesUpdated', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('favoritesUpdated', handleStorageChange);
    };
  }, []);

  const loadFavorites = () => {
    try {
      const stored = localStorage.getItem('favorites');
      if (stored) {
        const parsed = JSON.parse(stored);
        setFavorites(parsed);
      } else {
        setFavorites([]);
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
      setFavorites([]);
    }
  };

  const removeFavorite = (businessId) => {
    const updatedFavorites = favorites.filter(fav => fav.id !== businessId);
    setFavorites(updatedFavorites);
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
    window.dispatchEvent(new Event('favoritesUpdated'));
  };

  const handleBusinessClick = (business) => {
    navigate(`/business/${business.id}`, { 
      state: { business } 
    });
  };

  const getDefaultImage = (categoryId) => {
    const categoryImages = {
      'accommodation': '🏨',
      'eat_drink': '🍽️',
      'shopping': '🛍️',
      'see_do': '🎭',
      'health_fitness': '💪',
      'auto_rentals': '🚗',
      'professional_services': '💼',
      'banking': '🏦',
      'medical_services': '⚕️',
      'petrol_gas': '⛽'
    };
    
    return categoryImages[categoryId] || '📍';
  };

  if (favorites.length === 0) {
    return (
      <div className="favorites-page">
        <div className="favorites-header">
          <h1>My Favorites</h1>
          <p className="favorites-subtitle">Save your favorite places for quick access</p>
        </div>

        <div className="no-favorites">
          <div className="no-favorites-icon">💔</div>
          <h2>No Favorites Yet</h2>
          <p>Start exploring and save your favorite businesses</p>
          <button 
            className="explore-btn"
            onClick={() => navigate('/categories')}
          >
            Explore Categories
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="favorites-page">
      <div className="favorites-header">
        <h1>My Favorites</h1>
        <p className="favorites-subtitle">{favorites.length} saved {favorites.length === 1 ? 'place' : 'places'}</p>
      </div>

      <div className="favorites-grid">
        {favorites.map((business) => (
          <div
            key={business.id}
            className="favorite-card"
            onClick={() => handleBusinessClick(business)}
          >
            {business.imageUrls && business.imageUrls.length > 0 ? (
              <>
                <img 
                  src={business.imageUrls[0]} 
                  alt={business.name}
                  className="favorite-image"
                />
                <div className="favorite-overlay"></div>
              </>
            ) : (
              <div className="favorite-placeholder">
                <span className="favorite-emoji">{getDefaultImage(business.categoryId)}</span>
              </div>
            )}

            <button
              className="remove-favorite-btn"
              onClick={(e) => {
                e.stopPropagation();
                removeFavorite(business.id);
              }}
              aria-label="Remove from favorites"
            >
              ×
            </button>

            <div className="favorite-info">
              <h3>{business.name}</h3>
              {business.location && <p className="favorite-location">📍 {business.location}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FavoritesPage;
